// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Shadow UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* ezClockerStone Shadows: --ezBorderStone: #666565; */
  --ezStoneShadowColor: var(--ezStoneBorder);
  --ezStoneInsetBoxShadow: inset 0 0 4px 2px rgb(102 101 101 / 50%);
  --ezStoneBoxShadow: 0 0 1px 1px rgb(102 101 101 / 50%);
  --ezStoneInsetBottomShadow: inset 0 -2px 4px -2px rgb(102 101 101 / 50%);
  --ezStoneBottomShadow: 0 2px 2px -2px rgb(102 101 101 / 50%);
  --ezStoneTopShadow: 0 -2px 2px 0 rgb(102 101 101 / 50%);
  --ezStoneLeftShadow: -2px 0 2px 0 rgb(102 101 101 / 50%);
  --ezStoneRightShadow: 2px 0 2px 0 rgb(102 101 101 / 50%);
  --ezStoneTopRightShadow: 4px -4px 4px 0 rgb(102 101 101 / 50%);
  --ezStopTopLeftShadow: -4px -4px 4px 0 rgb(102 101 101 / 50%);
  --ezStoneBottomLeftShadow: -4px 4px 4px 0 rgb(102 101 101 / 50%);
  --ezStoneInsetTopLeft: inset 2px 2px 2px 0 rgb(102 101 101 / 50%);
  --ezStoneInsetTopRight: inset -2px 2px 2px 0 rgb(102 101 101 / 50%);
  /* ezClockerTeal Shadows: --ezTealBorder #007c82 */
  --ezTealShadowColor: var(--ezTealBorder);
  --ezTealInsetBoxShadow: inset 0 0 4px 2px rgb(0 124 130 / 100%);
  --ezTealBoxShadow: 0 0 1px 1px rgb(0 124 130 / 100%);
  --ezTealInsetBottomShadow: inset 0 -2px 4px -2px rgb(0 124 130 / 100%);
  --ezTealBottomShadow: 0 4px 4px -2px rgb(0 124 130 / 100%);
  --ezTealTopShadow: 0 -4px 4px 0 rgb(0 124 130 / 100%);
  --ezTealLeftShadow: -4px 0 4px 0 rgb(0 124 130 / 100%);
  --ezTealRightShadow: 4px 0 4px 0 rgb(0 124 130 / 100%);
  /* ezClockerNavy Shadows: --ezBorderNavy: #032746; */
  --ezNavyShadowColor: var(--ezBorderNavy);
  --ezNavyInsetShadow: inset 0 0 4px 2px rgb(3 39 70 / 100%);
  --ezNavyBoxShadow: 0 0 1px 1px rgb(3 39 70 / 100%);
  --ezNavyInsetBottomShadow: inset 0 -4px 4px 0 rgb(3 39 70 / 50%);
  --ezNavyBottomShadow: 0 2px 4px 0 rgb(3 39 70 / 100%);
  --ezNavyTopShadow: 0 -2px 2px 0 rgb(3 39 70 / 100%);
  --ezNavyLeftShadow: -2px 0 2px 0 rgb(3 39 70 / 100%);
  --ezNavyRightShadow: 2px 0 2px 0 rgb(3 39 70 / 100%);
  /* ezClockerBlack Shadows: --ezBorderBlack: #030101 */
  --ezBlackShadowColor: var(--ezBorderBlack);
  --ezBlackInsetBottomShadow: inset 0 -2px 4px -2px rgb(3 1 1 / 100%);
  --ezBlackBottomShadow: 0 2px 2px -2px rgb(3 1 1 / 100%);
  --ezBlackTopShadow: 0 -2px 2px 0 rgb(3 1 1 / 100%);
  --ezBlackLeftShadow: -2px 0 2px 0 rgb(3 1 1 / 100%);
  --ezBlackRightShadow: 2px 0 2px 0 rgb(3 1 1 / 100%);
  --ezBlackThickBottomShadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.8);
}

/* Shadows */
.ezShadows-0-0-10px-0-ezClockerBlack {
  box-shadow: 0 0 10px 0 var(--ezClockerBlack);
}

.ezShadows-inset-shadow {
  box-shadow: rgb(0, 0, 0) 3px 3px 6px 0 inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
}

.ez-bottom-shadow {
  box-shadow: 0 2px 2px 0 rgb(109 110 112/50%);
}

.ezShadows-wide-bottom-shadow {
  box-shadow: 0 4px 4px 0 rgb(109 110 112/50%);
}

.ez-inset-bottom-shadow {
  box-shadow: inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ezShadow-overlay-inset-bottom {
  box-shadow: inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ezShadow-overlay-inset-bottom:before {
  content: "";
  position: absolute;
  box-shadow: inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ez-right-shadow {
  box-shadow: 2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-inset-right-shadow {
  box-shadow: inset -2px 0 2px 0 rgb(109 110 112/50%);
}

.ezShadows-inset-right-left-bottom-shadow {
  box-shadow: inset -2px 0 2px 0 rgb(109 110 112/50%), inset 2px 0 2px 0 rgb(109 110 112/50%), inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ezShadows-inset-box-2px {
  box-shadow: inset 2px 0 2px 0 rgb(109 110 112/50%), inset -2px 0 2px 0 rgb(109 110 112/50%);
}

.ezShadows-inset-box-2px:after {
  box-shadow: inset 0 2px 2px 0 rgb(109 110 112/50%), inset 0 -4px 4px -2px rgb(109 110 112/50%);
}

.ez-left-shadow {
  box-shadow: -2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-left-right-shadow {
  box-shadow: 2px 0 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-inset-left-shadow {
  box-shadow: inset 2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-top-shadow {
  box-shadow: 0 -2px 2px 0 rgb(109 110 112/50%);
}

.ez-inset-top-shadow {
  box-shadow: inset 0 2px 2px 0 rgb(109 110 112/50%);
}

.ez-left-right-top-shadow {
  box-shadow: 2px 0 2px 0 rgb(109 110 112/50%), inset 0 2px 2px 0 rgb(109 110 112/50%), -2px 0 2px 0 rgb(109 110 112/50%);
}

.ez-left-right-bottom-shadow {
  box-shadow: 0 2px 4px 1px rgb(109 110 112/50%);
}

.ez-shadow {
  box-shadow: 0 0 4px 2px rgb(109 110 112/50%);
}

.ez-shadow-small {
  box-shadow: 0 0 2px 2px var(--ezClockerGray);
}

.ez-shadow-dark {
  box-shadow: 0 2px 8px 4px rgb(0 0 0/50%);
}

.ez-inset-shadow {
  box-shadow: inset 0 0 8px 4px rgb(109 110 112/50%);
}

.ez-small-inset-shadow {
  box-shadow: inset 0 0 4px 2px rgb(109 110 112/50%);
}

.ez-left-top-inset-shadow {
  box-shadow: inset 2px 2px 4px 2px rgb(109 110 112/50%);
}

/* DEPRECATED */
.leftRightBottomShadow {
  box-shadow: 0 2px 4px 1px rgb(109 110 112/50%);
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-shadows.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,sDAAA;EACA,0CAAA;EACA,iEAAA;EACA,sDAAA;EACA,wEAAA;EACA,4DAAA;EACA,uDAAA;EACA,wDAAA;EACA,wDAAA;EACA,8DAAA;EACA,6DAAA;EACA,gEAAA;EACA,iEAAA;EACA,mEAAA;EAEA,kDAAA;EACA,wCAAA;EACA,+DAAA;EACA,oDAAA;EACA,sEAAA;EACA,0DAAA;EACA,qDAAA;EACA,sDAAA;EACA,sDAAA;EAEA,oDAAA;EACA,wCAAA;EACA,0DAAA;EACA,kDAAA;EACA,gEAAA;EACA,qDAAA;EACA,mDAAA;EACA,oDAAA;EACA,oDAAA;EAEA,qDAAA;EACA,0CAAA;EACA,mEAAA;EACA,uDAAA;EACA,kDAAA;EACA,mDAAA;EACA,mDAAA;EACA,+DAAA;AAHJ;;AAMA,YAAA;AACA;EACI,4CAAA;AAHJ;;AAMA;EACI,8FACI;AAJR;;AAQA;EACI,4CAAA;AALJ;;AAQA;EACI,4CAAA;AALJ;;AAQA;EACI,sDAAA;AALJ;;AAQA;EACI,sDAAA;AALJ;;AAQA;EACI,WAAA;EACA,kBAAA;EACA,sDAAA;AALJ;;AAQA;EACI,4CAAA;AALJ;;AAQA;EACI,mDAAA;AALJ;;AAQA;EACI,uIAEI;AAPR;;AAcA;EACI,2FAEI;AAbR;;AAkBA;EACI,8FAEI;AAjBR;;AAsBA;EACI,6CAAA;AAnBJ;;AAsBA;EACI,+EAEI;AArBR;;AA0BA;EACI,kDAAA;AAvBJ;;AA0BA;EACI,6CAAA;AAvBJ;;AA0BA;EACI,kDAAA;AAvBJ;;AA0BA;EACI,uHAEI;AAzBR;;AAgCA;EACI,8CAAA;AA7BJ;;AAgCA;EACI,4CAAA;AA7BJ;;AAgCA;EACI,4CAAA;AA7BJ;;AAgCA;EACI,wCAAA;AA7BJ;;AAgCA;EACI,kDAAA;AA7BJ;;AAgCA;EACI,kDAAA;AA7BJ;;AAgCA;EACI,sDAAA;AA7BJ;;AAgCA,eAAA;AACA;EACI,8CAAA;AA7BJ;;AAgCA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Shadow UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n:root {\n    /* ezClockerStone Shadows: --ezBorderStone: #666565; */\n    --ezStoneShadowColor: var(--ezStoneBorder);\n    --ezStoneInsetBoxShadow: inset 0 0 4px 2px rgb(102 101 101 / 50%);\n    --ezStoneBoxShadow: 0 0 1px 1px rgb(102 101 101 / 50%);\n    --ezStoneInsetBottomShadow: inset 0 -2px 4px -2px rgb(102 101 101 / 50%);\n    --ezStoneBottomShadow: 0 2px 2px -2px rgb(102 101 101 / 50%);\n    --ezStoneTopShadow: 0 -2px 2px 0 rgb(102 101 101 / 50%);\n    --ezStoneLeftShadow: -2px 0 2px 0 rgb(102 101 101 / 50%);\n    --ezStoneRightShadow: 2px 0 2px 0 rgb(102 101 101 / 50%);\n    --ezStoneTopRightShadow: 4px -4px 4px 0 rgb(102 101 101 / 50%);\n    --ezStopTopLeftShadow: -4px -4px 4px 0 rgb(102 101 101 / 50%);\n    --ezStoneBottomLeftShadow: -4px 4px 4px 0 rgb(102 101 101 / 50%);\n    --ezStoneInsetTopLeft: inset 2px 2px 2px 0 rgb(102 101 101 / 50%);\n    --ezStoneInsetTopRight: inset -2px 2px 2px 0 rgb(102 101 101 / 50%);\n\n    /* ezClockerTeal Shadows: --ezTealBorder #007c82 */\n    --ezTealShadowColor: var(--ezTealBorder);\n    --ezTealInsetBoxShadow: inset 0 0 4px 2px rgb(0 124 130 / 100%);\n    --ezTealBoxShadow: 0 0 1px 1px rgb(0 124 130 / 100%);\n    --ezTealInsetBottomShadow: inset 0 -2px 4px -2px rgb(0 124 130 / 100%);\n    --ezTealBottomShadow: 0 4px 4px -2px rgb(0 124 130 / 100%);\n    --ezTealTopShadow: 0 -4px 4px 0 rgb(0 124 130 / 100%);\n    --ezTealLeftShadow: -4px 0 4px 0 rgb(0 124 130 / 100%);\n    --ezTealRightShadow: 4px 0 4px 0 rgb(0 124 130 / 100%);\n\n    /* ezClockerNavy Shadows: --ezBorderNavy: #032746; */\n    --ezNavyShadowColor: var(--ezBorderNavy);\n    --ezNavyInsetShadow: inset 0 0 4px 2px rgb(3 39 70 / 100%);\n    --ezNavyBoxShadow: 0 0 1px 1px rgb(3 39 70 / 100%);\n    --ezNavyInsetBottomShadow: inset 0 -4px 4px 0 rgb(3 39 70 / 50%);\n    --ezNavyBottomShadow: 0 2px 4px 0 rgb(3 39 70 / 100%);\n    --ezNavyTopShadow: 0 -2px 2px 0 rgb(3 39 70 / 100%);\n    --ezNavyLeftShadow: -2px 0 2px 0 rgb(3 39 70 / 100%);\n    --ezNavyRightShadow: 2px 0 2px 0 rgb(3 39 70 / 100%);\n\n    /* ezClockerBlack Shadows: --ezBorderBlack: #030101 */\n    --ezBlackShadowColor: var(--ezBorderBlack);\n    --ezBlackInsetBottomShadow: inset 0 -2px 4px -2px rgb(3 1 1 / 100%);\n    --ezBlackBottomShadow: 0 2px 2px -2px rgb(3 1 1 / 100%);\n    --ezBlackTopShadow: 0 -2px 2px 0 rgb(3 1 1 / 100%);\n    --ezBlackLeftShadow: -2px 0 2px 0 rgb(3 1 1 / 100%);\n    --ezBlackRightShadow: 2px 0 2px 0 rgb(3 1 1 / 100%);\n    --ezBlackThickBottomShadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.8);\n}\n\n/* Shadows */\n.ezShadows-0-0-10px-0-ezClockerBlack {\n    box-shadow: 0 0 10px 0 var(--ezClockerBlack);\n}\n\n.ezShadows-inset-shadow {\n    box-shadow:\n        rgb(0,0,0) 3px 3px 6px 0 inset,\n        rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;\n}\n\n.ez-bottom-shadow {\n    box-shadow: 0 2px 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ezShadows-wide-bottom-shadow {\n    box-shadow: 0 4px 4px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-inset-bottom-shadow {\n    box-shadow: inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\n}\n\n.ezShadow-overlay-inset-bottom {\n    box-shadow: inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\n}\n\n.ezShadow-overlay-inset-bottom:before {\n    content: '';\n    position: absolute;\n    box-shadow: inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\n}\n\n.ez-right-shadow {\n    box-shadow: 2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-inset-right-shadow {\n    box-shadow: inset -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ezShadows-inset-right-left-bottom-shadow {\n    box-shadow:\n        /* right */\n        inset -2px 0 2px 0 rgb(109 110 112 / 50%),\n        /* left */\n        inset 2px 0 2px 0 rgb(109 110 112 / 50%),\n        /* bottom */\n        inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\n}\n\n.ezShadows-inset-box-2px {\n    box-shadow:\n        /* left */\n        inset 2px 0 2px 0 rgb(109 110 112 / 50%),\n        /* right */\n        inset -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ezShadows-inset-box-2px:after {\n    box-shadow:\n        /* top */\n        inset 0 2px 2px 0 rgb(109 110 112 / 50%),\n        /* bottom */\n        inset 0 -4px 4px -2px rgb(109 110 112 / 50%);\n}\n\n.ez-left-shadow {\n    box-shadow: -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-left-right-shadow {\n    box-shadow:\n        /* left */\n        2px 0 2px 0 rgb(109 110 112 / 50%),\n        /* right */\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-inset-left-shadow {\n    box-shadow: inset 2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-top-shadow {\n    box-shadow: 0 -2px 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-inset-top-shadow {\n    box-shadow: inset 0 2px 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-left-right-top-shadow {\n    box-shadow:\n        /* left */\n        2px 0 2px 0 rgb(109 110 112 / 50%),\n        /* top */\n        inset 0 2px 2px 0 rgb(109 110 112 / 50%),\n        /* right */\n        -2px 0 2px 0 rgb(109 110 112 / 50%);\n}\n\n.ez-left-right-bottom-shadow {\n    box-shadow: 0 2px 4px 1px rgb(109 110 112 / 50%);\n}\n\n.ez-shadow {\n    box-shadow: 0 0 4px 2px rgb(109 110 112 / 50%);\n}\n\n.ez-shadow-small {\n    box-shadow: 0 0 2px 2px var(--ezClockerGray);\n}\n\n.ez-shadow-dark {\n    box-shadow: 0 2px 8px 4px rgb(0 0 0 / 50%);\n}\n\n.ez-inset-shadow {\n    box-shadow: inset 0 0 8px 4px rgb(109 110 112 / 50%);\n}\n\n.ez-small-inset-shadow {\n    box-shadow: inset 0 0 4px 2px rgb(109 110 112 / 50%);\n}\n\n.ez-left-top-inset-shadow {\n    box-shadow: inset 2px 2px 4px 2px rgb(109 110 112 / 50%);\n}\n\n/* DEPRECATED */\n.leftRightBottomShadow {\n    box-shadow: 0 2px 4px 1px rgb(109 110 112 / 50%);\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
